var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("404"),_c('br'),_vm._v("\n\t"+_vm._s(_vm.tr.not_found))])])}
var staticRenderFns = []

export { render, staticRenderFns }